<vdw-message-container [showTitle]="true" [title]="'PRODUCTION_ORDER.WEAVE_PLAN.CONFIRMATION.WARNINGS.SUBTITLE' | bmsTranslate" [messages]="getMessages()"></vdw-message-container>
